import React, { useEffect, useState,memo } from 'react';
import { faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Handle, Position } from 'reactflow';
import styled from 'styled-components';
import { faUser } from '@fortawesome/free-regular-svg-icons';

const NodeContainer = styled.div`
  padding: 10px;
  border-radius: 8px;
  background: #CCF2FF;
  border: 1px solid #0099CC;
  width: 200px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
`;

const NodeHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const NodeIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #0099CC;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 8px;
`;

const NodeLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #0099CC;
  flex: 1;
`;

const NodeType = styled.div`
  font-size: 10px;
  background: rgba(0, 65, 208, 0.1);
  color: #0041d0;
  padding: 2px 6px;
  border-radius: 4px;
`;

const NodeDescription = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
`;

const NodeDetails = styled.div`
  font-size: 11px;
  color: #777;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DetailItem = styled.div`
  display: flex;
`;

const DetailLabel = styled.span`
  font-weight: 500;
  margin-right: 5px;
`;

const DetailValue = styled.span`
  color: #555;
`;




const AgentNode = ({ data }) => {
  const {
    id= 'node-'+new Date().getTime(),
    name = 'Unnamed Agent',
    description = 'No description provided',
    type = 'Agent',
    tags = [],
    capabilities = [],
   
  } = data;


  return (
    <NodeContainer>
      <Handle type="target" position={Position.Top} />

      <NodeHeader>
        <NodeIcon>
          <FontAwesomeIcon icon={faUser} />
        </NodeIcon>
        <NodeLabel>{name}</NodeLabel>
        {/* <NodeType>{type || 'Agent'}</NodeType> */}
      </NodeHeader>

      <NodeDescription>{description}</NodeDescription>

      <NodeDetails>
        {tags.length > 0 && (
          <DetailItem>
            <DetailLabel>Tags:</DetailLabel>
            <DetailValue>{tags.join(', ')}</DetailValue>
          </DetailItem>
        )}

        {capabilities.length > 0 && (
          <DetailItem>
            <DetailLabel>Capabilities:</DetailLabel>
            <DetailValue>{capabilities.slice(0, 2).join(', ')}{capabilities.length > 2 ? '...' : ''}</DetailValue>
          </DetailItem>
        )}

        {/* {model_code && (
          <DetailItem>
            <DetailLabel>Model:</DetailLabel>
            <DetailValue>{model_code}</DetailValue>
          </DetailItem>
        )}

        {hosted_on && (
          <DetailItem>
            <DetailLabel>Hosted On:</DetailLabel>
            <DetailValue>{hosted_on}</DetailValue>
          </DetailItem>
        )}

        {data_encryption !== undefined && (
          <DetailItem>
            <DetailLabel>Encryption:</DetailLabel>
            <DetailValue>{data_encryption ? 'Enabled' : 'Disabled'}</DetailValue>
          </DetailItem>
        )}

        {pii_handling !== undefined && (
          <DetailItem>
            <DetailLabel>PII Handling:</DetailLabel>
            <DetailValue>{pii_handling ? 'Enabled' : 'Disabled'}</DetailValue>
          </DetailItem>
        )} */}
      </NodeDetails>

      <Handle type="source" position={Position.Bottom} />
    </NodeContainer>
  );
};

export default memo(AgentNode);